/**
=========================================================
* Soft UI Dashboard React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/



import React, { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FormControlLabel, Box } from "@mui/material";
// react-router-dom components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import Table from 'react-bootstrap/Table';
import { Pagination } from "react-bootstrap";
import { authUserRegistration,authDistributionChannel,authLocation } from '../../../assets/globalAPI/GlobalApi';
// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftSelect";
import {  IconButton, Modal, Dialog, DialogActions, DialogContent, DialogTitle,TextField, Grid, CardContent, CardHeader } from '@mui/material';
// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import Socials from "layouts/authentication/components/Socials";
import Separator from "layouts/authentication/components/Separator";
import curved9 from "assets/images/anmolb.png";
import anmolLogo from "../../../assets/images/anmol_logo_transparent.png"
// Images
import curved6 from "assets/images/curved-images/curved14.jpg";
import { createUser } from "assets/globalAPI/apiGlobal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { fetchRoleMaster } from "assets/globalAPI/apiGlobal";
import SimpleBackdrop from "layouts/SimpleBackdrop";
import { getAllUsers } from "assets/globalAPI/apiGlobal";
import '../../style.css'

function SignUp() {
  const [agreement, setAgremment] = useState(true);
  const [isActive, setIsActive] = useState(false);
   const [open, setOpen]= useState(false);
   const [open2, setOpen2]= useState(false);
  const toastId = React.useRef(null);
  const MySwal = withReactContent(Swal);
  const[userAccess,setUserAccess] = useState('');
  const[userID,setUserID] = useState('');
  const[selectUserType,setSelectUserType] = useState('');
  const[selectDC,setselectDC] = useState('');
  const[selectLocation,setSelectLocation] = useState('');
  const[distributionChannel,setDistributionChannel] = useState({});
  const[locationValue,setLocation] = useState({});
  const [desig,setDesig]= useState("")
  const [depart,setDepart]= useState("")
  const [roles,setRoles]=useState([]);
  const [users,setUsers]=useState([]);
  const [selectedRole,setSelectedRole]=useState("");
  const [selectedRoleName,setSelectedRoleName]=useState("");
  const [memberOf,setMemberOf]= useState("")
  const [memberOfName,setMemberOfName]= useState("")
   const [userSearch,setUserSearch]= useState("");
      const typingTimeoutRef = React.useRef(null);
            const latestSearchRef = React.useRef("");
  const navigate = useNavigate();
     const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPages, setTotalPages]= useState(1);
    const [totalRolePages, setTotalRolePages]= useState(1);
    const [currentPage, setCurrentPage]= useState(1);
    const [rolePage, setRolePage]= useState(1);
  // useEffect(() => {
  //   if (localStorage.getItem('userid_details')) { 
  //     let session = localStorage.getItem('userid_details');
  //     let userid_array =JSON.parse(session);
  //     let userid = userid_array.userid;
  //     let user_type = userid_array.user_type;
  //     setUserAccess(user_type);
  //     setUserID(userid);
  //     }else{
  //       // navigate('/');
  //     }
      
  //     const data = {
  //       "action": 'distributionChannel'
  //     };
    
  //     const location_data = {
  //       "action": 'location'
  //     };
    
  //     authDistributionChannel(JSON.stringify(data)).then(function(response) {
  //       var res = response.data;
  //         if(res.status=='true' && res.code=='200')
  //         {
  //           setDistributionChannel(res.array);
  //         }else{
  //           setDistributionChannel(res.array);
  //       }
  //       }.bind(this)
  //   )
  //   .catch(function(error) {
     
  //     console.log(error);
    
  //   });
    
    
  //   authLocation(JSON.stringify(location_data)).then(function(response) {
  //     var res = response.data;
  //       if(res.status=='true' && res.code=='200')
  //       {
  //         setLocation(res.array);
  //       }else{
  //         setLocation(res.array);
  //     }
  //     }.bind(this)
  //   )
  //   .catch(function(error) {
    
  //   console.log(error);
    
  //   });
    

 
  // },[userID]);


// const handleUserType = async (event) => {
  
//   setSelectUserType(event.value);
// }
// const handleDC = async (event) => {
  
//   setselectDC(event.value);
// }
// const handleLocation = async (event) => {
  
//   setSelectLocation(event.value);
// }

const fetchRoles = async () => {
  setIsActive(true)
  const body={
    page: rolePage
  }
    try {
      const response = await fetchRoleMaster(body); // Replace with your API
      const res= response.data;
      if(res.status){
        setRoles(res.data);

        console.log("Roles fetched successfully:", res.data);
        setTotalRolePages(res.totalPages)
        setIsActive(false)
      }else{
        console.log("Roles not fetched>> ", res)
        setTotalRolePages(1);
        setIsActive(false)
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      setTotalRolePages(1);
      setIsActive(false)
      if(error.response?.status==403){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.error("Your Session has expired",{
            className:"small-toast"
          })
        }
        setIsActive(false)
        setTimeout(()=>{
          navigate("/")
          localStorage.clear();
        },2000)
        return;
      }
    }
  };

  useEffect(() => { 
    fetchRoles()
  }, [rolePage]);
  
  const handleSetAgremment = () => setAgremment(!agreement);

  const handleSubmit = async (event) => {
    
    event.preventDefault();
    setIsActive(true)
    let name = document.getElementById('name').value;
    let userid = document.getElementById('userid').value;
    let email = document.getElementById('email').value;
    let password = document.getElementById('password').value;
    let password2 = document.getElementById('password2').value;
    let designation = desig;
    let department= depart;
    let isAdmin = document.getElementById('isAdmin').checked ? 1 : 0;
    let role= selectedRole
    console.log("desig-->", document.getElementById('designation').value);
   if(name=='' || userid=='' || email=='' || password=='' || password2== '' || designation=='' || department=='' || role== ''  )
   {
    if(! toast.isActive(toastId.current)) {
      toastId.current = toast.warning("Mandatory field(s) missing!",{
        className: 'small-toast'
      });  
      setIsActive(false)
      return;
    }
   }else{
    if(password!== password2){
      if(! toast.isActive(toastId.current)) {
        toastId.current = toast.warning("Password does not match",{
          className
          : "small-toast"
        });  
      }
      return;
    }
    const data = {
     "userid":userid,
    "name":name,
    "email":email,
    "password":password,
    "user_type":"initiator",
    "designation":designation,
    "department":department,
     "member_of": memberOf==""?0:memberOf,
    "user_role": role,
    "isadmin":isAdmin

    }
    console.log("sign up body-->",data);
   try{
    const response= await createUser(data);
    const res= response.data;
    console.log("The response after registering>> ", res);
    if(res.status){
      if(! toast.isActive(toastId.current)) {
        toastId.current = toast.success(res.message,{
          className: "small-toast"
        });  
      }
      console.log("the success>> ", res);
     setIsActive(false)

    }else{
      if(! toast.isActive(toastId.current)) {
        toastId.current = toast.error(res.message,{
          className: "small-toast"
        });  
      }
      console.log("failed to create>> ", res)
      setIsActive(false)
    }
   }catch(error){
    if(! toast.isActive(toastId.current)) {
      toastId.current = toast.error("Error creating user",{
        className: "small-toast"
      });  
    }
    setIsActive(false)
    if(error.response?.status==403){
      if(!toast.isActive(toastId.current)){
        toastId.current= toast.error("Your Session has expired",{
          className:"small-toast"
        })
      }
      setTimeout(()=>{
        navigate("/")
        localStorage.clear();
      },2000)
      return;
    }
    console.log("Error in registering>> ", error)
   }

   }

  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

   const handlePageChange2 = (page) => {
    setRolePage(page);
  };

  const handleUserChange = (selectedOption) => {
   setMemberOf(selectedOption.id);
   setMemberOfName(selectedOption.name)
    console.log("upadted used is>> ", selectedOption)
    setOpen(false);
  };

  const fetchAllUsers=async()=>{
    setIsActive(true)
    const body={
        page: latestSearchRef.current==""? currentPage:1,
        search: latestSearchRef.current
    }
    try{
        const response= await getAllUsers(body);
        const res= response.data;
        console.log("response is>> ", res)
        if(res.status){
          setIsActive(false)
            console.log("all users fetched>> ", res);
            setUsers(res.data);
            setTotalPages(res.totalPages)
        }else{
          setIsActive(false)
            console.log("could not fetch users>> ", res);
            setTotalPages(1)
            setUsers([])
        }
    }catch(err){
      setIsActive(false)
        console.log("the error is bringing users>> ", err)
        
    }
  }
   useEffect(()=>{
          fetchAllUsers();
        },[currentPage])

  const handleOpenDialog=()=>{
    
      setOpen(true);
  }
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setUserSearch(value);
    latestSearchRef.current = value;

    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);

   
typingTimeoutRef.current = setTimeout(() => {
  fetchAllUsers(); // Inside this function, access latest value from latestSearchRef.current
}, 2000);
}

  return (
    
    <DashboardLayout>

      <DashboardNavbar/>

      <ToastContainer />
      <SimpleBackdrop openLoader={isActive}/>
      <Card sx={{width: "100%", alignSelf: "center", margin: "auto"}}>
        <div style={{width:"80%", margin: "auto", paddingTop: "20px"}}>
        <SoftBox p={3} s >
          <SoftTypography variant="h5" fontWeight="medium">
            User Creation
          </SoftTypography>
        </SoftBox>
        
       
        <SoftBox pt={0} pb={3} px={3}>
          <SoftBox>
          <form noValidate onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <SoftBox mb={2}>
                  <SoftInput placeholder="Name" name="name" id="name" />
                </SoftBox>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SoftBox mb={2}>
                  <SoftInput placeholder="USER ID" name="userid" id="userid" />
                </SoftBox>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SoftBox mb={2}>
                <SoftInput type="email" placeholder="Email" name="email" id="email" />
                </SoftBox>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SoftBox mb={2}>
                  <SoftInput type="password" placeholder="Password" name="password" id="password" />
                </SoftBox>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SoftBox mb={2}>
                  <SoftInput type="password" placeholder="Confirm Password" name="password2" id="password2" />
                </SoftBox>
              </Grid>
              <Grid item xs={12} sm={6}>
                <SoftBox mb={2}>
                  <SoftSelect placeholder="Designation" name="designation" id="designation"  
                  options={[
                    { value: "ASM", label: "ASM" },
                    { value: "Infra Officer", label: "Infra Officer" },
                    { value: "RSM", label: "RSM" },
                    { value: "Trade Marketing Manager", label: "Trade Marketing Manager" },
                    { value: "ZSM", label: "ZSM" },
                    { value: "NSM", label: "NSM" },
                    { value: "MDM", label: "MDM" },
                    { value: "Sales", label: "Sales" },
                    { value: "Accounts", label: "Accounts" },
                    { value: "BIZOM", label: "BIZOM" },
                    { value: "Supply Chain Management", label: "Supply Chain Management" },
                    { value: "MIS", label: "MIS" },
                    { value: "Others", label: "Others" },
                  ]} 
                  onChange={(e)=>setDesig(e.value)} 
                  />
                </SoftBox>
               </Grid>
               <Grid item xs={12} sm={6}>
                  <SoftBox mb={2}>
                    <SoftInput placeholder="Role" name="role" id="role"  
                    value={selectedRoleName}
                    // options={roles} 
                    // menuPlacement="auto"
                    // menuTarget={document.body}
                    // menuPosition="fixed"
                    onClick={()=>{
                      
                      setOpen2(true)}} 
                    />
                  </SoftBox>
               </Grid>
                <Grid item xs={12} sm={6}>
                    <SoftBox mb={2}>
                    <SoftSelect placeholder="Designation" name="designation" id="designation"  
                  options={[
                    { value: 'Company Secretarial', label: 'Company Secretarial' },
                    { value: 'CSR', label: 'CSR' },
                    { value: 'Director Office', label: 'Director Office' },
                    { value: 'Export', label: 'Export' },
                    { value: 'Finance & Accounts', label: 'Finance & Accounts' },
                    { value: 'HR/IR/Admin', label: 'HR/IR/Admin' },
                    { value: 'Information Technology', label: 'Information Technology' },
                    { value: 'Legal Compliances', label: 'Legal Compliances' },
                    { value: 'Management', label: 'Management' },
                    { value: 'Marketing', label: 'Marketing' },
                    { value: 'Operation', label: 'Operation' },
                    { value: 'Projects', label: 'Projects' },
                    { value: 'Purchase', label: 'Purchase' },
                    { value: 'Quality', label: 'Quality' },
                    { value: 'Real Estate', label: 'Real Estate' },
                    { value: 'R&D /Innovation', label: 'R&D /Innovation' },
                    { value: 'Sales', label: 'Sales' },
                    { value: 'Supply Chain Management', label: 'Supply Chain Management' }
                  ]
                  } 
                  onChange={(e)=>setDepart(e.value)} 
                  />
                    </SoftBox>
                </Grid>
                <Grid item xs={12} sm={6}>
                   <SoftBox mb={2}>
                      <TextField value={memberOfName} placeholder="Member Of.." sx={{cursor: 'pointer'}} onClick={() =>{ 
                                  
                      handleOpenDialog()
                                    }} variant="outlined" fullWidth />
                  </SoftBox>
                </Grid>
                <Grid item xs={12} sm={12}>
                  <Box mb={2}>
                    <FormControlLabel 
                      control={<Checkbox name="isAdmin" id="isAdmin" />} 
                      label="Is Admin?" 
                    />
                  </Box>
                </Grid>
            </Grid>
            
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <SimpleBackdrop openLoader={isActive}/>
        <DialogTitle>Select a User</DialogTitle>
        <DialogContent>
          <input
                                    type="text"
                                    placeholder="Search using Name or Code"
                                    value={userSearch}
                                    onChange={(e) => handleSearchChange(e)}
                                    style={{
                                      width: "100%",
                                      padding: "5px",
                                      marginBottom: "10px",
                                      fontSize: "12px",
                                    }}
                                  />
          <>
          <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
          <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>NAME</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>EMAIL</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>USER ID</th>
          <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>ACTION</th>
        </tr>
      </thead>
              {/* <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>User ID</TableCell>
                  <TableCell>Plant</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead> */}
               <tbody>
                                                         
                                                             <>
                                                             {users && users.map((user) => (
                                                               <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={user.id}>
                                                                 <td>{user.name}</td>
                                                                 <td>{user.email}</td>
                                                                 <td>{user.userid}</td>
                                                                 <td>
                                                                   <SoftButton variant="contained" size="small" color="error" onClick={() => handleUserChange(user)}>Select</SoftButton>
                                                                 </td>
                                                               </tr>
                                                             ))}
                                                             </>
                                                             {users?.length === 0 ? (
  <SoftTypography variant="caption">No Users Found</SoftTypography>
) : null}
                                                         </tbody>
            </Table>
          </>
         <Pagination className="mt-3">
                                     <Pagination.Prev 
                                       disabled={currentPage === 1} 
                                       onClick={() => handlePageChange(currentPage - 1)}
                                     />
                                     {[...Array(totalPages).keys()].map((page) => (
                                       <Pagination.Item 
                                         key={page + 1} 
                                         active={page + 1 === currentPage} 
                                         onClick={() => handlePageChange(page + 1)}
                                       >
                                         {page + 1}
                                       </Pagination.Item>
                                     ))}
                                     <Pagination.Next 
                                       disabled={currentPage === totalPages} 
                                       onClick={() => handlePageChange(currentPage + 1)}
                                     />
                                   </Pagination>
        </DialogContent>
      </Dialog>

         <Dialog open={open2} onClose={() => setOpen2(false)} maxWidth="md" fullWidth>
        <SimpleBackdrop openLoader={isActive}/>
        <DialogTitle>Select a Role</DialogTitle>
        <DialogContent>
          {/* <input
                                    type="text"
                                    placeholder="Search using Name or Code"
                                    value={userSearch}
                                    onChange={(e) => handleSearchChange(e)}
                                    style={{
                                      width: "100%",
                                      padding: "5px",
                                      marginBottom: "10px",
                                      fontSize: "12px",
                                    }}
                                  /> */}
          <>
          <Table striped bordered hover size="sm" style={{ fontSize: 12 }}>
          <thead>
        <tr style={{ color: "white", backgroundColor: "#3498db" }}>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>NAME</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>CUSTOMER VIEW</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>CUSTOMER APPROVAL</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>CUSTOMER EDIT</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>VENDOR VIEW</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>VENDOR APPROVAL</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>VENDOR EDIT</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL VIEW</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL CREATE</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>MATERIAL APPROVAL</th>
        <th style={{ whiteSpace: 'nowrap', backgroundColor: '#FF2C2C', color: '#FFFFF0' }}>ACTION</th>

        </tr>
      </thead>
               <tbody>
                                                         
                                                             <>
                                                             {roles && roles.map((user) => (
                                                               <tr style={{ whiteSpace: 'nowrap', fontSize: "12px" }} key={user.id}>
                                                                 <td>{user.role_name}</td>
                                                                 <td>{user.customer_view}</td>
                                                                 <td>{user.customer_approval}</td>
                                                                 <td>{user.customer_edit}</td>
                                                                 <td>{user.vendor_view}</td>
                                                                 <td>{user.vendor_approval}</td>
                                                                 <td>{user.vendor_edit}</td>
                                                                 <td>{user.material_view}</td>
                                                                 <td>{user.material_create}</td>
                                                                 <td>{user.material_approval}</td>
                                                                 <td>
                                                                   <SoftButton variant="contained" size="small" color="error" onClick={() => {
                                                                    setOpen2(false)
                                                                    setSelectedRoleName(user.role_name)
                                                                    setSelectedRole(user.role_id)}}>Select</SoftButton>
                                                                 </td>
                                                               </tr>
                                                             ))}
                                                             </>
                                                             {roles?.length === 0 ? (
  <SoftTypography variant="caption">No Roles Found</SoftTypography>
) : null}
                                                         </tbody>
            </Table>
          </>
         <Pagination className="mt-3">
                                     <Pagination.Prev 
                                       disabled={rolePage === 1} 
                                       onClick={() => handlePageChange2(rolePage - 1)}
                                     />
                                     {[...Array(totalRolePages).keys()].map((page) => (
                                       <Pagination.Item 
                                         key={page + 1} 
                                         active={page + 1 === rolePage} 
                                         onClick={() => handlePageChange2(page + 1)}
                                       >
                                         {page + 1}
                                       </Pagination.Item>
                                     ))}
                                     <Pagination.Next 
                                       disabled={rolePage === totalRolePages} 
                                       onClick={() => handlePageChange2(rolePage + 1)}
                                     />
                                   </Pagination>
        </DialogContent>
      </Dialog>
            {/* <SoftBox mb={2}>
            <SoftSelect
                  name="dc"
                  onChange={handleDC}
                  options={distributionChannel}  
                
                />
            </SoftBox> */}
            {/* <SoftBox mb={2}>
            <SoftSelect
                  name="location"
                  onChange={handleLocation}
                  options={locationValue}  
                
                />
            </SoftBox> */}
            {/* <SoftBox mb={2}>
            <SoftSelect
                  name="user_type"
                  onChange={handleUserType}
                  options={[
                    { value: "initiator", label: "Initiator" },
                    { value: "support", label: "Exporter" }
                  ]}  
                
                />
            </SoftBox> */}
            <SoftBox mt={4} mb={1}>
              <SoftButton variant="gradient" color="error" fullWidth type="submit">
                Create
              </SoftButton>
            </SoftBox>
            </form>
            <SoftBox mt={3} textAlign="center">
              <SoftTypography variant="button" color="text" fontWeight="regular">
               
                {/* <SoftTypography
                  component={Link}
                  to="/dashboard"
                  variant="button"
                  color="dark"
                  fontWeight="bold"
                  textGradient
                >
                  Go Back
                </SoftTypography> */}
              </SoftTypography>
            </SoftBox>
          </SoftBox>
        </SoftBox>

        </div>
        
        
        
      </Card>
    </DashboardLayout>
      
  );
}

export default SignUp;
